import { render, staticRenderFns } from "./OrgStaff.vue?vue&type=template&id=7810a5dc&scoped=true&"
import script from "./OrgStaff.vue?vue&type=script&lang=js&"
export * from "./OrgStaff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7810a5dc",
  null
  
)

export default component.exports